import componentStyles from './KeihinBody.module.scss';

function KeihinBody() {
  return (
    <div className={`${componentStyles.mtSmall} ${componentStyles.textHtml} ${componentStyles.textSmall}`}>
      <h2>
        <strong>梱包資材や緩衝材など</strong>
      </h2>
      <p>
        ・外袋や台紙などの梱包資材や緩衝材を頭から被ったり、顔を覆ったりしないでください。窒息する恐れがあります。開封後は速やかに廃棄してください。
      </p>
      <p>・小さなお子様は誤飲、窒息する恐れがありますので絶対に与えないでください。</p>
      <br />
      <h2>
        <strong>全景品共通</strong>
      </h2>
      <p>・製品を本来の用途以外でご使用しないでください。</p>
      <p>
        ・製品を火気等の熱源に近づけたり、近くに置かないでください。本体の破損、変形、変色、やけど、火災の原因となる恐れがあります。
      </p>
      <p>・高温、多湿、水中、直射日光のあたる場所での使用や保管はしないでください。</p>
      <p>・製品を装着時に発生した破損や故障につきましては、責任を負いかねますのであらかじめご了承ください。</p>
      <p>・思わぬ事故の恐れがありますので、小さなお子様の手の届かないところでご使用、保管してください。</p>
      <p>・小さなお子様は誤飲、窒息する恐れがありますので絶対に与えないでください。</p>
      <p>・安全のため、破損や変形した場合は使用を中止してください。</p>
      <p>・表面を尖ったものや金属製品で傷つけないでください。</p>
      <p>・破損の原因となりますので、製品に過度な力を加えないでください。</p>
      <h2>
        <strong>アクリル</strong>
      </h2>

      <p>
        ・本体と台座をセットする場合、過度な力を加えたり、取付部分を無理な方向に強く引っ張ったり曲げたりしないでください。破損の原因になります。
      </p>
      <p>
        ・小さな部品がありますので小さなお子様が誤って飲み込まないように注意してください。窒息などの危険性があります。
      </p>
      <p>・尖った部品がありますので取り扱いには十分ご注意ください。思わぬ怪我をする恐れがあります。</p>
      <h2>
        <strong>缶バッジ</strong>
      </h2>
      <p>・安全ピンの特性上、生地を傷める場合があります。</p>
      <p>・尖った部品がありますので、取り扱いには十分ご注意ください。思わぬ怪我をする恐れがあります。</p>
      <h2>
        <strong>クリアポスター</strong>
      </h2>
      <p>・丸めた状態で長時間放置すると折り目やシワが付いてしまう可能性がございますのでご注意ください。</p>
      <p>・先端が尖っている箇所がありますので、ご注意ください。</p>
      <h2>
        <strong>クリアファイル、ポストカード、ミニカードなどのカード・紙類</strong>
      </h2>
      <p>・先端が尖っている箇所がありますので、ご注意ください。</p>
      <h2>
        <strong>Tシャツ、タペストリーなどの布類</strong>
      </h2>
      <p>・洗濯をすると色落ちする場合がございますので他のものとの洗濯はお控えください。</p>
      <br />
    </div>
  );
}

export default KeihinBody;
